// ============================================================
// Notifications API
// ============================================================

import apiClient from './client';

export interface Notification {
  id: number;
  type: string;
  title: string;
  message: string;
  link: string;
  is_read: boolean;
  created_at: string;
}

export interface NotificationsResponse {
  notifications: Notification[];
  unread_count: number;
}

/**
 * Get user notifications
 * @param limit - Maximum number of notifications to fetch (default 5)
 */
export async function getNotifications(limit = 5): Promise<NotificationsResponse> {
  const response = await apiClient.get<NotificationsResponse>(`/notifications/?limit=${limit}`);
  return response.data;
}

/**
 * Mark all notifications as read
 */
export async function markAllNotificationsAsRead(): Promise<{ success: boolean; updated_count: number }> {
  const response = await apiClient.post<{ success: boolean; updated_count: number }>('/notifications/');
  return response.data;
}
